// extracted by mini-css-extract-plugin
export var caption = "WhyLearnWithUs-module--caption--73d9d";
export var image = "WhyLearnWithUs-module--image--adcfb";
export var speechBubbleText = "WhyLearnWithUs-module--speechBubbleText--6f462";
export var whyLearn = "WhyLearnWithUs-module--whyLearn--0524e";
export var whyLearnCard = "WhyLearnWithUs-module--whyLearnCard--01779";
export var whyLearnContent = "WhyLearnWithUs-module--whyLearnContent--8d46c";
export var whyLearnContentText = "WhyLearnWithUs-module--whyLearnContentText--4c283";
export var whyLearnContentTitle = "WhyLearnWithUs-module--whyLearnContentTitle--b1e61";
export var whyLearnImageContainer = "WhyLearnWithUs-module--whyLearnImageContainer--4496b";
export var whyLearnSpeechBubble1 = "WhyLearnWithUs-module--whyLearnSpeechBubble1--7eed4";
export var whyLearnSpeechBubble2 = "WhyLearnWithUs-module--whyLearnSpeechBubble2--ca1dd";
export var whyLearnTitle = "WhyLearnWithUs-module--whyLearnTitle--e3633";
export var whyLearnwithuscontainer = "WhyLearnWithUs-module--whyLearnwithuscontainer--ef8b2";